import AdminCenter from '@/pages/adminCenter/index.vue';
import AdminLogin from '@/pages/adminCenter/login.vue';

import ArticleRouter from '@/router/admin/article';
import ComprehensiveRouter from '@/router/admin/comprehensive';
import ProductRouter from '@/router/admin/product';
import EnArticleRouter from '@/router/admin/en/article';
import EnComprehensiveRouter from '@/router/admin/en/comprehensive';
import EnProductRouter from '@/router/admin/en/product';
import User from '@/pages/adminCenter/page/user';
import EN from '@/pages/adminCenter/page/en';

/* eslint-disable */
const AdminRouter = [{
    path: '/admin',
    name: 'admin',
    component: AdminCenter,
    children: [
      ...ArticleRouter,
      ...ComprehensiveRouter,
      ...ProductRouter,
      {
        path: 'user',
        component: User
      }, {
        path: 'en',
        component: EN,
        children: [...EnArticleRouter,
          ...EnComprehensiveRouter,
          ...EnProductRouter,
        ]
      }
    ]
  },
  {
    path: '/admin_login',
    name: 'admin_login',
    component: AdminLogin,
  }
];
export default [
  ...AdminRouter
]



// WEBPACK FOOTER //
// ./src/router/admin/index.js